import React, { useEffect } from "react";
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField,
} from "@mui/material";
import {
    AppIconsCloseStyled,
    CloseIconWrapper,
    DialogContentStyled,
    StyledBox,
    StyledDialogTitle,
    StyledTypographyTitle,
    TextConfirmButtonStyled,
} from "./BasketListDialog.style";
import { AppIconsCart, AppIconsClose } from "../../../AppIcons";
import { StyleguideSavioColors } from "../../../../configuration/themeSettings";
import { StyledDialogActions } from "./AddBasketButton.style";
import CommonDialog from "../../../CommonDialog/CommonDialog";

export const RenameBasketDialog: React.FC<{
    defaultOpen: boolean;
    name: string;
    basketId: number;
    onClose: any;
    onRename: any;
}> = ({ onClose, onRename, defaultOpen, name, basketId }) => {
    const [open, setOpen] = React.useState(defaultOpen);
    const [value, setValue] = React.useState(name);

    const { t } = useTranslation();
    useEffect(() => {
        setOpen(defaultOpen);
    }, [defaultOpen]);
    useEffect(() => {
        setValue(name);
    }, [name]);

    const handleClose = () => {
        setOpen(false);
        onClose(false);
    };

    return (
        <CommonDialog
            open={open}
            dialogTitleLabel="basket.renameTitle"
            dialogContentLabel="basket.basketChangeName"
            closeDialog={handleClose}
            confirmButton={() => {
                if (!onRename(basketId, value)) {
                    setValue(name);
                }
            }}
        >
            <TextField
                autoFocus
                variant="standard"
                margin="dense"
                id="name"
                label={(
                    t("common.spareparts.basket.basket_name") as string
                ).toUpperCase()}
                placeholder={(
                    t("common.spareparts.basket.basket_name") as string
                ).toUpperCase()}
                type="text"
                fullWidth
                slotProps={{
                    input: {
                        color: "primary",
                    },
                    htmlInput: {
                        color: StyleguideSavioColors.grey,
                    },
                }}
                value={value}
                onChange={(event: any) => {
                    if (
                        event.target.value != null &&
                        event.target.value.length <= 100
                    ) {
                        setValue(event.target.value);
                    }
                }}
            />
        </CommonDialog>
    );
};
